import { render } from "./deliveryRecord.vue?vue&type=template&id=d2399d14&scoped=true"
import script from "./deliveryRecord.vue?vue&type=script&lang=js"
export * from "./deliveryRecord.vue?vue&type=script&lang=js"

import "./deliveryRecord.vue?vue&type=style&index=0&id=d2399d14&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2399d14"]])

export default __exports__